import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    width: 100%;
    max-width: 100%;
    gap: 2rem;
    padding: 2rem;
`

const MainContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-width: 0; // This prevents flex child from overflowing
`

interface VideoLayoutProps {
    children: React.ReactNode
    currentVideoId: string
}

const VideoLayout: React.FC<VideoLayoutProps> = ({ children, currentVideoId }) => {
    return (
        <Container>
            <MainContent>{children}</MainContent>
        </Container>
    )
}

export default VideoLayout
